import { Fragment, useEffect, useState } from 'react';
import moment from 'moment';
import { GradeCard } from './GradeCard';
import Back from '../../../../assets/images/chevrons-left.svg';
import Down from '../../../../assets/images/chevron-down.svg';
import { CustomTooltip } from '../../../../shared/Tooltip';

const GradesTable = ({ grades = [], onToggle = null }) => {
  const [expandedRows, setExpandedRows] = useState([]);
  const [expandedChapters, setExpandedChapters] = useState([]);
  let newGrades = [...grades];
  const allChapters = [];
  const allActivities = [];
  useEffect(() => {
    if (grades.length === 1) {
      setExpandedRows([grades[0].sectionNumber]);
    }
  }, [grades]);

  grades.forEach((element) => {
    element.students.forEach((student) => {
      student.chapters.forEach((chap) => {
        if (allChapters.findIndex((x) => x.chapter === chap.chapter) === -1) {
          allChapters.push(chap);
        }
        chap.activities.forEach((act) => {
          if (allActivities.findIndex((x) => x.activityId === act.activityId) === -1) {
            allActivities.push({ ...act, students: [student._id] });
          } else {
            allActivities[
              allActivities.findIndex((x) => x.activityId === act.activityId)
            ].students.push(student._id);
          }
        });
      });
    });
  });
  newGrades.forEach((sect) => {
    sect.students.forEach((student) => {
      for (let all = 0; all < allChapters.length; all++) {
        const element = allChapters[all];
        if (student.chapters.findIndex((x) => x.chapter === element.chapter) === -1) {
          student.chapters.push({ ...element, avgGrade: '--' });
        }
      }
    });
  });
  allChapters.sort((a, b) => a.chapter - b.chapter);

  const expandRow = (i) => {
    if (expandedRows.includes(i)) {
      setExpandedRows(expandedRows.filter((e) => e !== i));
    } else {
      setExpandedRows((old) => [...old, i]);
    }
  };
  const expandChapter = (i) => {
    if (expandedChapters.includes(i)) {
      setExpandedChapters(expandedChapters.filter((e) => e !== i));
    } else {
      setExpandedChapters((old) => [...old, i]);
    }
  };

  return (
    <div className='grade_table_wrapper'>
      <table className='grades_table' style={{ width: '100%' }}>
        <tr>
          <th className='w-10'>Student Name</th>
          <th className='w-10'>Grade</th>
          {newGrades.length > 0 && (
            <th colSpan={allActivities.length + allChapters.length}>Chapters/activities</th>
          )}
          {!newGrades.length && <th className='w-100'>Chapters/activities</th>}
        </tr>
        <tbody>
          {!newGrades.length && (
            <Fragment>
              <tr className='parent_row'>
                <td className='parent_cell w-20'>
                  <p className='d-flex justify-content-start align-items-center gap-1 m-0 text-uppercase'>
                    <span
                      className='text-purple cursor text-decoration-underline'
                      onClick={onToggle}
                    >
                      Add Section
                    </span>
                    To Class
                  </p>
                </td>
                <td className='parent_cell w-10 border-start-0 border-end-0'></td>
                <td className='parent_cell border-start-0'>
                  <p className='d-flex justify-content-center align-items-center m-0 gap-1 text-uppercase'>
                    <span className='text-purple cursor text-decoration-underline'>Associate</span>
                    a Book to this class
                  </p>
                </td>
              </tr>
            </Fragment>
          )}
          {newGrades.map((r, index) => (
            <Fragment key={index}>
              <tr className='parent_row'>
                <td className={`parent_cell ${index < 2 ? 'min-width-240' : ''}`}>
                  <p
                    className={`mb-0 internal_p ${
                      index === 0 ? 'd-flex justify-content-start align-items-center gap-3' : ''
                    }`}
                  >
                    {' '}
                    section {r.sectionNumber.split('-')[0]}{' '}
                    <img
                      className={`cursor down ${
                        expandedRows.includes(r.sectionNumber) && 'rotated'
                      }`}
                      onClick={() => {
                        expandRow(r.sectionNumber);
                      }}
                      src={Down}
                      alt=''
                    />
                  </p>
                </td>
                <td className='parent_cell' style={{ textAlign: 'start' }}>
                  {Math.round(r.avgGrade)}%
                </td>
                {allChapters.map((chapter, indx) => (
                  <Fragment key={indx}>
                    <td className='parent_cell'>
                      <p className='mb-0 internal_p'>
                        ch. {chapter.chapter}{' '}
                        <img
                          className={`cursor back ${
                            expandedChapters.includes(chapter.chapter) && 'rotated'
                          }`}
                          src={Back}
                          alt=''
                          onClick={() => {
                            expandChapter(chapter.chapter);
                          }}
                        />
                      </p>
                    </td>
                    {expandedChapters.includes(chapter.chapter) && (
                      <Fragment>
                        {chapter.activities.map((act, ind) => (
                          <td className='parent_cell' key={ind}>
                            {act.activityTitle.length > 7 ? (
                              <CustomTooltip position='top' content={act.activityTitle}>
                                <span>{`${act.activityTitle.slice(0, 7)}...`}</span>
                              </CustomTooltip>
                            ) : (
                              act.activityTitle
                            )}
                          </td>
                        ))}
                      </Fragment>
                    )}
                  </Fragment>
                ))}
              </tr>
              {expandedRows.includes(r.sectionNumber) && (
                <Fragment>
                  {' '}
                  {r.students.map((student, _index) => (
                    <tr key={_index}>
                      <td className='text-align-start pe-0'>
                        <CustomTooltip
                          position='top'
                          content={`${student.firstName} ${student.lastName}`}
                        >
                          <span>
                            {`${student.firstName} ${student.lastName}`.slice(0, 12) + '...'}
                          </span>
                        </CustomTooltip>
                      </td>
                      <td style={{ textAlign: 'start' }}>
                        {student.avgGrade === null ? '--' : Math.round(student.avgGrade)}%
                      </td>
                      {student.chapters
                        .sort((a, b) => a.chapter - b.chapter)
                        .map((chap, ind) => (
                          <Fragment key={ind}>
                            <td className='parent_cell'>
                              {chap.avgGrade === null ? '--' : Math.round(chap.avgGrade)}%
                            </td>
                            {expandedChapters.includes(chap.chapter) && (
                              <Fragment>
                                {chap.activities.map((act, indx) => {
                                  const createByStd = act.activityAnswers.filter(
                                    (e) => e.createdBy === student._id
                                  );

                                  let per = null;
                                  const activity = act.activityAnswers?.[0]?.answers?.[0] || {};
                                  if (createByStd.length) {
                                    per = act.avgGrade;
                                  }
                                  const expired = new moment().isAfter(new moment(act.dueDate));
                                  const due = new moment().isBefore(new moment(act.dueDate));

                                  return (
                                    <GradeCard
                                      key={indx}
                                      {...{
                                        due,
                                        expired,
                                        per,
                                        activity,
                                        index,
                                        _index,
                                      }}
                                    />
                                  );
                                })}
                              </Fragment>
                            )}
                          </Fragment>
                        ))}
                    </tr>
                  ))}
                </Fragment>
              )}
            </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GradesTable;
